import styled from 'styled-components';
import { colors, fonts } from '../../css';

// eslint-disable-next-line
export const StyledLink = styled.a`
  color: ${colors.colorBlue};
  text-decoration: underline;
  font-family: ${fonts.fontBold};
  font-size: 1em;
`;
